module.exports = __webpack_public_path__ + "img/4.13f53b3c.png";